module.exports = __webpack_public_path__ + "img/flor8.dc077ee7.gif";